import React, { useEffect } from 'react';

import { useViewportHeight } from 'hooks/useViewportHeight';

interface ViewportHeightProviderProps {
  children: React.ReactNode;
}

export const ViewportHeightProvider: React.FC<ViewportHeightProviderProps> = ({ children }) => {
  const { vh, realHeight, isSafari, isMobile } = useViewportHeight();

  useEffect(() => {
    // Aplica as variáveis CSS dinamicamente
    const root = document.documentElement;

    // Define a altura real da viewport
    root.style.setProperty('--vh', `${vh}px`);
    root.style.setProperty('--real-vh', `${realHeight}px`);

    // Para Safari no iOS, aplica ajustes específicos
    if (isSafari && isMobile) {
      root.style.setProperty('--safari-vh', `${realHeight}px`);

      // Adiciona classe específica para Safari iOS
      document.body.classList.add('safari-ios');
    } else {
      document.body.classList.remove('safari-ios');
    }

    // Adiciona classe para dispositivos móveis
    if (isMobile) {
      document.body.classList.add('mobile-device');
    } else {
      document.body.classList.remove('mobile-device');
    }

    console.log('[ViewportHeightProvider]', {
      vh,
      realHeight,
      isSafari,
      isMobile,
      safeAreaBottom: getComputedStyle(root).getPropertyValue('--safe-area-inset-bottom'),
    });
  }, [vh, realHeight, isSafari, isMobile]);

  return <>{children}</>;
};

export default ViewportHeightProvider;
